export default {
  components: {},
  props: {
    screen: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      website: {
        name: '昌邑石化销售绩效管理平台',
        gaba: '鲁公安网备37078602370906',
        gabaLink: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37078602370906&token=e1ade62f-1355-452b-9c63-b60742b5f30b',
        icpba: '鲁ICP备19054251号-1 ',
        icpbaLink: 'http://beian.miit.gov.cn/?token=e1ade62f-1355-452b-9c63-b60742b5f30b'
      },
      url: {
        getFooterManualList: SZH.assets.api + "/Custom/GetFooterManualList",
      },
      links: {
        Agreement: {
          title: '隐私协议',
          list: []
        },
        Manual: {
          title: '用户手册',
          list: []
        },
        PayHelp: {
          title: '支付帮助',
          list: []
        },
        Service: {
          title: '售后服务',
          list: []
        },
        About: {
          title: '关于我们',
          list: []
        },
      }
    }
  },
  methods: {
    turnTo(url) {
        var newRoute = urlSplit(url);
        if(!newRoute.compare(this.$route)) {
            this.$router.push({
                path: url
            })
        }
    },
    getFooterManualList() {
      var self = this;
      self.$http.post(self.url.getFooterManualList, {}).then(result => {
          if (result.State == 1 && result.Data) {
            for(var i in result.Data) {
              this.links[i].list = result.Data[i];
            }
          } else {
          }
      }, () => {
      });
    }
  },
  created() {
  },
  computed: {
    isPhone() {
      return this.screen.width <= 450;
    }
  },
  mounted() {
    this.website.name = SZH.WebSite.name;
    this.website.gaba = SZH.WebSite.gaba;
    this.website.gabaLink = SZH.WebSite.gabaLink;
    this.website.icpba = SZH.WebSite.icpba;
    this.website.icpbaLink = SZH.WebSite.icpbaLink;

    this.getFooterManualList();
  },
  watch: {}
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js